import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserKycApplicationDetailsDto } from '../../../_core/_model/compliance';
import { ComplianceApiService } from '../../../_core/_services/_compliance/compliance-api.service';
import { NotificationService } from '../../../_core/_services/notification.service';

@Component({
  selector: 'app-compliance-success',
  standalone: false,
  templateUrl: './compliance-success.html',
  styleUrl: './compliance-success.css',
})
export class ComplianceSuccess  implements OnInit {
  application: UserKycApplicationDetailsDto | null = null;
  applicationId = '';
  loading = false;
  error: string | null = null;

  constructor(
    private notifyService: NotificationService,
    private route: ActivatedRoute,
    private api: ComplianceApiService
  ) {}

  ngOnInit(): void {
    this.applicationId = this.route.snapshot.paramMap.get('applicationId') || '';

    if (!this.applicationId) {
      this.error = 'Application not found.';
      this.notifyService.showError(this.error!, 'Error');
      return;
    }

    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = null;

    this.api.getApplicationById(this.applicationId).subscribe({
      next: (res) => {
        this.application = res.data || null;
        this.loading = false;
      },
      error: (err) => {
        this.error = err?.error?.message || 'Failed to load submitted application.';
        this.notifyService.showError(this.error!, 'Error');
        this.loading = false;
      }
    });
  }
}